export default (originalName) => {
  return originalName.replaceAll(" ", "_");
};
